import { useState } from 'react';
import { Eye, EyeSlash, LockKey } from 'shared/icons';
import api from '../../services/api';
import Button from '../ui/Button';
import Input from '../ui/Input';
import Modal from '../ui/Modal';

const ChangePasswordModal = ({ isOpen, onClose, onSuccess }) => {
    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [showPasswords, setShowPasswords] = useState({
        current: false,
        new: false,
        confirm: false,
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
        setShowPasswords({ current: false, new: false, confirm: false });
        setErrors({});
        onClose();
    };

    const validateForm = () => {
        const nextErrors = {};

        if (!formData.currentPassword) {
            nextErrors.currentPassword = 'Senha atual e obrigatoria';
        }

        if (!formData.newPassword) {
            nextErrors.newPassword = 'Nova senha e obrigatoria';
        } else if (formData.newPassword.length < 8) {
            nextErrors.newPassword = 'Senha deve ter no minimo 8 caracteres';
        }

        if (!formData.confirmPassword) {
            nextErrors.confirmPassword = 'Confirmacao e obrigatoria';
        } else if (formData.newPassword !== formData.confirmPassword) {
            nextErrors.confirmPassword = 'Senhas nao coincidem';
        }

        if (formData.currentPassword && formData.currentPassword === formData.newPassword) {
            nextErrors.newPassword = 'Nova senha deve ser diferente da atual';
        }

        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) {
            return;
        }

        try {
            setLoading(true);
            await api.updatePassword({
                current_password: formData.currentPassword,
                new_password: formData.newPassword,
            });

            onSuccess?.('Senha alterada com sucesso');
            handleClose();
        } catch (error) {
            setErrors({ submit: error?.message || 'Erro ao alterar senha' });
        } finally {
            setLoading(false);
        }
    };

    const renderPasswordField = ({ id, label, value, error, visibleKey, placeholder }) => (
        <div className="relative">
            <Input
                label={label}
                type={showPasswords[visibleKey] ? 'text' : 'password'}
                value={value}
                onChange={(event) =>
                    setFormData((previous) => ({
                        ...previous,
                        [id]: event.target.value,
                    }))
                }
                className="pr-10"
                error={error}
                placeholder={placeholder}
            />
            <button
                type="button"
                onClick={() =>
                    setShowPasswords((previous) => ({
                        ...previous,
                        [visibleKey]: !previous[visibleKey],
                    }))
                }
                className="absolute right-3 top-[38px] text-mono-500 hover:text-mono-700 dark:hover:text-mono-300"
            >
                {showPasswords[visibleKey] ? <EyeSlash size={18} /> : <Eye size={18} />}
            </button>
        </div>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            title="Alterar Senha"
            icon={<LockKey size={24} className="text-black dark:text-white" />}
            size="md"
        >
            <form onSubmit={handleSubmit} className="space-y-4">
                {renderPasswordField({
                    id: 'currentPassword',
                    label: 'Senha Atual',
                    value: formData.currentPassword,
                    error: errors.currentPassword,
                    visibleKey: 'current',
                    placeholder: 'Digite sua senha atual',
                })}

                {renderPasswordField({
                    id: 'newPassword',
                    label: 'Nova Senha',
                    value: formData.newPassword,
                    error: errors.newPassword,
                    visibleKey: 'new',
                    placeholder: 'Digite a nova senha',
                })}

                {renderPasswordField({
                    id: 'confirmPassword',
                    label: 'Confirmar Nova Senha',
                    value: formData.confirmPassword,
                    error: errors.confirmPassword,
                    visibleKey: 'confirm',
                    placeholder: 'Digite a nova senha novamente',
                })}

                {errors.submit ? (
                    <div className="p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                        <p className="text-sm text-red-500 dark:text-red-400">{errors.submit}</p>
                    </div>
                ) : null}

                <div className="flex gap-3 pt-2">
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={handleClose}
                        className="flex-1"
                        disabled={loading}
                    >
                        Cancelar
                    </Button>
                    <Button type="submit" className="flex-1" loading={loading}>
                        Alterar Senha
                    </Button>
                </div>
            </form>
        </Modal>
    );
};

export default ChangePasswordModal;
